import graphicsSrc from "@/assets/connect-to-scm-showcase-graphics.svg";
import { forwardRef } from "react";

export const ConnectToScmShowcase = forwardRef<HTMLDivElement>(function ConnectToScmShowcase(_props, ref) {
    return (
        <div ref={ref} className="flex h-full w-full flex-col items-center justify-center p-4">
            <img
                src={graphicsSrc}
                alt="Graphics for keeping momentum on any device"
                className="mb-6 max-h-[75%] w-auto select-none object-contain"
            />
            <p className="mb-2 text-center text-2xl font-medium text-black lg:text-3xl dark:text-white">
                Keep momentum on any device
            </p>
            <p className="max-w-lg text-center text-base text-content-secondary lg:text-lg">
                Transition seamlessly between Ona&#x2019;s conversational interface, native VS Code in the browser or
                any desktop IDE.
            </p>
        </div>
    );
});
